import { render } from "./UkrainianLanguage.vue?vue&type=template&id=17032366"
import script from "./UkrainianLanguage.vue?vue&type=script&lang=js"
export * from "./UkrainianLanguage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__